import { SliceZone } from '@prismicio/react'
import * as prismicH from '@prismicio/helpers'

import { createClient } from '../prismicio'
import { components } from '../slices'
import Head from "next/head";
import { Layout } from "../components";

const Page = ({ page, headerLinks, footer }) => (
  <>
    <Head>
      <title>
        {`${page.data.meta_title || page.data.title[0].text} - Arjen Miedema Web Development`}
      </title>
      {page.data.meta_description && <meta name="description" content={page.data.meta_description}/>}
    </Head>
    <Layout headerLinks={headerLinks} page={page} footer={footer}>
      <SliceZone slices={page.data.slices || page.data.body} components={components} context={{page}} />
    </Layout>
  </>
);

export default Page

export async function getStaticProps({ params, previewData }) {
  const client = createClient({ previewData })

  const page = await client.getByUID('page', params.uid, {
    fetchLinks: 'case.title, case.image, case.type, page.title'
  });

  const headerNavigation = await client.getSingle('header_navigation'),
    footer = await client.getSingle('footer_navigation');

  return {
    props: {
      page,
      headerLinks: headerNavigation?.data?.menu_items || [],
      footer
    },
  }
}

export async function getStaticPaths() {
  const client = createClient()

  const pages = await client.getAllByType('page')

  return {
    paths: pages.map((page) => prismicH.asLink(page)),
    fallback: false,
  }
}
